<div class="wrapper-blocked">
	<img src="assets/images/cavo_logo_rev.svg" alt="logo" />
	<div class="content">
		<p>Your account has been deactivated. Please contact your administrator to enable your account.</p>
		<div class="login-button text-center">
			<button class="btn btn-primary" type="button" (click)="goToLogin()">Return to Login</button>
		</div>
	</div>
</div>
